export interface GzSelectionCardItem {
  id: string;
  label: string;
  value: string | number;
  disabled?: boolean;
  selected?: boolean;
}

export enum SelectionCardEvents {
  CHANGE = 'change',
  CARD_SELECTED = 'cardSelected',
}

export class SelectionCardEventType extends CustomEvent<{
  id: string;
  value: string | number;
}> {}
